__webpack_require__.p = "/design-stack/pixartprinting/3.13.2/";